export default __webpack_public_path__ + "static/testimonialCompanyLogo4-1d85b2410b08e88e52cb0159811c0d5b.svg";